/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from "@tanstack/react-query";

import { useCallback } from "react";

import type {
    AcceptSignupCodeParams,
    ApiResult,
    CheckSignupCodeParams,
    IlluminateUser,
} from "./query.schemas";

import { useCustomFetchClient } from "./mutator/custom-fetch";
import type { ErrorType } from "./mutator/custom-fetch";

/**
 * Get details of the currently logged-in user
 */
export const useGetMyAccountInfoHook = () => {
    const getMyAccountInfo = useCustomFetchClient<IlluminateUser>();

    return useCallback(
        (signal?: AbortSignal) => {
            return getMyAccountInfo({
                url: `/myaccount/info`,
                method: "GET",
                signal,
            });
        },
        [getMyAccountInfo],
    );
};

export const getGetMyAccountInfoQueryKey = () => {
    return [`/myaccount/info`] as const;
};

export const useGetMyAccountInfoQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
    TError = ErrorType<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
            TError,
            TData
        >
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetMyAccountInfoQueryKey();

    const getMyAccountInfo = useGetMyAccountInfoHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>
    > = ({ signal }) => getMyAccountInfo(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyAccountInfoQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>
>;
export type GetMyAccountInfoQueryError = ErrorType<unknown>;

export function useGetMyAccountInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
    TError = ErrorType<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyAccountInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyAccountInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyAccountInfo<
    TData = Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
    TError = ErrorType<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useGetMyAccountInfoHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useGetMyAccountInfoQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Accept a signup code. Call this *before* calling GetMyAccountInfo or any other endpoint for the first time.
 */
export const useAcceptSignupCodeHook = () => {
    const acceptSignupCode = useCustomFetchClient<ApiResult>();

    return useCallback(
        (params: AcceptSignupCodeParams, signal?: AbortSignal) => {
            return acceptSignupCode({
                url: `/myaccount/accept-signup-code`,
                method: "PUT",
                params,
                signal,
            });
        },
        [acceptSignupCode],
    );
};

export const useAcceptSignupCodeMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>,
        TError,
        { params: AcceptSignupCodeParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>,
    TError,
    { params: AcceptSignupCodeParams },
    TContext
> => {
    const mutationKey = ["acceptSignupCode"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const acceptSignupCode = useAcceptSignupCodeHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>,
        { params: AcceptSignupCodeParams }
    > = (props) => {
        const { params } = props ?? {};

        return acceptSignupCode(params);
    };

    return { mutationFn, ...mutationOptions };
};

export type AcceptSignupCodeMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>
>;

export type AcceptSignupCodeMutationError = ErrorType<unknown>;

export const useAcceptSignupCode = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>,
            TError,
            { params: AcceptSignupCodeParams },
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAcceptSignupCodeHook>>>,
    TError,
    { params: AcceptSignupCodeParams },
    TContext
> => {
    return useMutation(
        useAcceptSignupCodeMutationOptions(options),
        queryClient,
    );
};
/**
 * Check if the signup code is valid
 */
export const useCheckSignupCodeHook = () => {
    const checkSignupCode = useCustomFetchClient<ApiResult>();

    return useCallback(
        (params: CheckSignupCodeParams, signal?: AbortSignal) => {
            return checkSignupCode({
                url: `/myaccount/check-signup-code`,
                method: "GET",
                params,
                signal,
            });
        },
        [checkSignupCode],
    );
};

export const getCheckSignupCodeQueryKey = (params?: CheckSignupCodeParams) => {
    return [
        `/myaccount/check-signup-code`,
        ...(params ? [params] : []),
    ] as const;
};

export const useCheckSignupCodeQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
    TError = ErrorType<unknown>,
>(
    params: CheckSignupCodeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
                TError,
                TData
            >
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getCheckSignupCodeQueryKey(params);

    const checkSignupCode = useCheckSignupCodeHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>
    > = ({ signal }) => checkSignupCode(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CheckSignupCodeQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>
>;
export type CheckSignupCodeQueryError = ErrorType<unknown>;

export function useCheckSignupCode<
    TData = Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
    TError = ErrorType<unknown>,
>(
    params: CheckSignupCodeParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useCheckSignupCodeHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useCheckSignupCodeHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckSignupCode<
    TData = Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
    TError = ErrorType<unknown>,
>(
    params: CheckSignupCodeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<ReturnType<typeof useCheckSignupCodeHook>>
                    >,
                    TError,
                    Awaited<
                        ReturnType<ReturnType<typeof useCheckSignupCodeHook>>
                    >
                >,
                "initialData"
            >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckSignupCode<
    TData = Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
    TError = ErrorType<unknown>,
>(
    params: CheckSignupCodeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useCheckSignupCode<
    TData = Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
    TError = ErrorType<unknown>,
>(
    params: CheckSignupCodeParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<ReturnType<typeof useCheckSignupCodeHook>>>,
                TError,
                TData
            >
        >;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = useCheckSignupCodeQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Accept the terms and conditions of the web, located at https://jetcharge.com.au/end-use-terms/
 */
export const useAcceptTermsAndConditionsHook = () => {
    const acceptTermsAndConditions = useCustomFetchClient<ApiResult>();

    return useCallback(
        (signal?: AbortSignal) => {
            return acceptTermsAndConditions({
                url: `/myaccount/accept-terms-conditions`,
                method: "PUT",
                signal,
            });
        },
        [acceptTermsAndConditions],
    );
};

export const useAcceptTermsAndConditionsMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ["acceptTermsAndConditions"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const acceptTermsAndConditions = useAcceptTermsAndConditionsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>>,
        void
    > = () => {
        return acceptTermsAndConditions();
    };

    return { mutationFn, ...mutationOptions };
};

export type AcceptTermsAndConditionsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>>
>;

export type AcceptTermsAndConditionsMutationError = ErrorType<unknown>;

export const useAcceptTermsAndConditions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>
            >,
            TError,
            void,
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useAcceptTermsAndConditionsHook>>>,
    TError,
    void,
    TContext
> => {
    return useMutation(
        useAcceptTermsAndConditionsMutationOptions(options),
        queryClient,
    );
};
/**
 * Log out the current user
 */
export const useLogOutHook = () => {
    const logOut = useCustomFetchClient<ApiResult>();

    return useCallback(
        (signal?: AbortSignal) => {
            return logOut({ url: `/myaccount/logout`, method: "PUT", signal });
        },
        [logOut],
    );
};

export const useLogOutMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ["logOut"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const logOut = useLogOutHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>,
        void
    > = () => {
        return logOut();
    };

    return { mutationFn, ...mutationOptions };
};

export type LogOutMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>
>;

export type LogOutMutationError = ErrorType<unknown>;

export const useLogOut = <TError = ErrorType<unknown>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>,
            TError,
            void,
            TContext
        >;
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useLogOutHook>>>,
    TError,
    void,
    TContext
> => {
    return useMutation(useLogOutMutationOptions(options), queryClient);
};
